<template>
  <el-autocomplete
    v-model="state"
    class="inline-input"
    :fetch-suggestions="querySearch"
    placeholder="请输入发货单号"
    clearable
    size="small"
    :popper-append-to-body="false"
    @select="handleSelect($event)"
    :loading="loading"
  >
    <template slot-scope="{ item }">
      <div class="name">{{ item.billNo }}</div>
      <span class="addr"
        >{{ item.deliverarea }} - {{ item.deliveraddress }}<br />生成时间：{{
          parseTime(item.createdate)
        }}</span
      >
    </template>
  </el-autocomplete>
</template>

<script>
export default {
  props: {
    shipmentNumber: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      shipmentNumberList: [],
      state: "",
      loading: false,
    };
  },
  created() {
    this.getOddlist();
  },
  watch: {
    state: {
      immediate: true,
      handler(state) {
        this.$emit("input", state);
      },
    },
    shipmentNumber: {
      immediate: true,
      handler(state) {
        this.state = state;
      },
    },
  },
  methods: {
    // 根据客户号查询发货单
    getOddlist() {
      this.loading = true;
      let params = {
        dateFrom: this.$moment().subtract(7,'day').format('YYYY-MM-DD'),
        dateTo: this.$moment(new Date(Date.now())).format('YYYY-MM-DD'),
      }
      this.$Api.searchShipList(params).then((res) => {
        this.loading = false;
        this.shipmentNumberList = res.data?res.data.deliverheaderList:[];
      });
    },
    // 搜索建议的模糊搜索
    querySearch(queryString, cb) {
      var restaurants = this.shipmentNumberList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.billNo.toLowerCase().indexOf(queryString.toLowerCase()) !==
          -1
        );
      };
    },
    // 选中发货单号后回填数据
    handleSelect(item) {
      this.state = item.billNo;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-popper {
  width: auto !important;
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>